/**
 * @module constants/ViewActions
 */

/**
 * The exposed, namespaced View related actions.
 */
export const ViewActions = Object.freeze({
  OPEN_DROPDOWN: 'OPEN_DROPDOWN',
  CLOSE_DROPDOWN: 'CLOSE_DROPDOWN',

  OPEN_SHARE_MODAL: 'OPEN_SHARE_MODAL',
  SHOWED_SHARE_MODAL: 'SHOWED_SHARE_MODAL',

  OPEN_EDUCATION_MODAL: 'OPEN_EDUCATION_MODAL',

  OPEN_MODAL: 'OPEN_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',

  TOGGLE_TPR_TEXT: 'TOGGLE_TPR_TEXT',

  OPEN_MODAL_COACHMARK: 'OPEN_MODAL_COACHMARK',
  OPEN_MODAL_READONLYMODE: 'OPEN_MODAL_READONLYMODE',

  // action corresponding to the popup for an action that requires registration
  OPEN_SIGNUP_LOGIN_MODAL: 'OPEN_SIGNUP_LOGIN_MODAL',

  OPEN_NOW_PLAYING: 'OPEN_NOW_PLAYING',
  CLOSE_NOW_PLAYING: 'CLOSE_NOW_PLAYING',

  OPEN_BACKSTAGE: 'OPEN_BACKSTAGE',
  SHOWED_BACKSTAGE_PAGE: 'SHOWED_BACKSTAGE_PAGE',
  SHOWED_BACKSTAGE_ARTIST_PAGE_ON_ROUTE: 'SHOWED_BACKSTAGE_ARTIST_PAGE_ON_ROUTE',

  OPEN_SESSION_HISTORY: 'OPEN_SESSION_HISTORY',
  CLOSE_SESSION_HISTORY: 'CLOSE_SESSION_HISTORY',
  SET_SESSION_HISTORY_INDEX: 'SET_SESSION_HISTORY_INDEX',

  HOVERED_OVER_STATION_LIST: 'HOVERED_OVER_STATION_LIST',
  HOVERED_OUT_STATION_LIST: 'HOVERED_OUT_STATION_LIST',
  CLICKED_SEARCH_BOX_COMPONENT: 'CLICKED_SEARCH_BOX_COMPONENT',

  SHOWED_COLLECTION_PAGE: 'SHOWED_COLLECTION_PAGE',
} as const);

export default ViewActions;
